import { useCallback, useEffect, useRef, useState } from 'react'
import { toast } from 'react-toastify'
import Dropzone from '../../../components/Dropzone'
import InputText from '../../../components/Forms/InputText'
import PageLoader from '../../../components/PageLoader'
import { Progress } from '../../../components/Progress'
import { useModal } from '../../../contexts/ModalContext'
import api from '../../../services/api'
import Template from '../../../template'
import * as S from './style'

function AdminBanner () {
  const [banners, setBanners] = useState()
  const [params, setParams] = useState({})
  const [errors] = useState({})

  const { openModal, closeModal } = useModal()
  const dragItem = useRef()
  const dragEnterItem = useRef()
  const [progressValue, setProgressValue] = useState(0)
  const dragStart = (evt, position) => {
    dragItem.current = position
  }

  const dragEnter = (evt, position) => {
    dragEnterItem.current = position
  }
  const PATH = 'banner'
  const drop = useCallback(
    async (e) => {
      const newList = [...banners]
      const dragItemContent = newList[dragItem.current]
      newList.splice(dragItem.current, 1)
      newList.splice(dragEnterItem.current, 0, dragItemContent)
      const reordered = newList.map((list, index) => {
        list.order = index
        return list
      })
      await api.put(
        '/banner/reorder',
        reordered.map((list) => {
          return {
            bannerId: list.id,
            order: list.order
          }
        })
      )
      setBanners(reordered)
    },
    [banners]
  )

  const handleSubmit = useCallback(
    async (evt) => {
      evt.preventDefault()
      try {
        if (!params.id) {
          const response = await api.post('/banner/', params)
          setBanners((banners) => [response.data, ...banners])
          toast.success('Banner postado com sucesso!', { theme: 'colored' })
        } else {
          const response = await api.put('/banner/', params)
          const currentBanners = banners.filter(
            (banner) => banner.id !== params.id
          )
          setBanners([response.data, ...currentBanners])
          toast.success('Banner atualizado com sucesso!', { theme: 'colored' })
        }
        resetDropzone()
      } catch (error) {
        console.log(error)
        toast.error('Não foi possível postar o banner. Verifique as informações e/ou tente novamente.', { theme: 'colored' })
      }
    },
    [banners, params]
  )

  const loadBanners = useCallback(async () => {
    const response = await api.get('/banner/')
    setBanners(response.data.banners)
  }, [])

  const handleEdit = useCallback((banner) => {
    setParams(banner)
  }, [])

  const handleConfirmDelete = useCallback(
    async (bannerId) => {
      try {
        await api.delete(`/banner/${bannerId}`)
        const newBanners = banners.filter((banner) => banner.id !== bannerId)
        setBanners([...newBanners])
        closeModal()
      } catch (error) { }
    },
    [banners, closeModal]
  )

  const handleDeleteConfirm = useCallback(
    async (bannerId) => {
      openModal({
        header: 'Atenção',
        body: (
          <>
            Essa ação é irreversivel, deseja continuar?
            <S.Buttons>
              <button className="button primary" onClick={closeModal}>
                Não
              </button>
              <button
                className="button tertiary"
                onClick={() => handleConfirmDelete(bannerId)}
              >
                Sim
              </button>
            </S.Buttons>
          </>
        )
      })
    },
    [closeModal, handleConfirmDelete, openModal]
  )

  const resetDropzone = useCallback(() => {
    setParams({ path: '', link: '' })
    setProgressValue(0)
  }, [])

  useEffect(() => {
    loadBanners()
  }, [loadBanners])

  const onDrop = (image) => {
    setParams({ ...params, imageId: image.id, path: image.path })
  }
  const onDropImage = useCallback(
    async (acceptedFiles) => {
      const formData = new FormData()
      formData.append('image', acceptedFiles[0])
      const response = await api.post(`/admin-upload/${PATH}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (e) => {
          // let progress = Math.round((e.loaded * 100) / e.total);
        }
      })
      onDrop(response.data.image)
      handleProgress()
    },
    [onDrop, PATH]
  )

  if (!banners) return <PageLoader />
  const handleProgress = async () => {
    setProgressValue(0)
    const totalSteps = 10
    const delay = 100

    for (let i = 1; i <= totalSteps; i++) {
      await new Promise((resolve) => setTimeout(resolve, delay))
      const newProgress = Math.round((i / totalSteps) * 100)
      setProgressValue(newProgress)
    }
  }
  return (
    <Template>
      <div style={{ marginTop: '8rem' }}></div>
      <div className="account-hub-content">
        <S.Container className="widget-box">
          <form
            onSubmit={handleSubmit}
            className="widget-box-content"
            style={{ position: 'relative' }}
          >
            <S.ImageContainer>
              <Dropzone
                mimeTypes={{ 'image/*': [] }}
                typeName="Banner"
                handleOndrop={onDropImage}
                path={PATH}
                image={params.path}
                message=" Tamanho mínimo: 1184px &times; 300px"
              >{progressValue === 0 ? '' : <Progress color="#615dfa" progress={progressValue} width={1} />}</Dropzone>
            </S.ImageContainer>

            <S.Grid>
              <InputText
                name="name"
                value={params.link}
                onChange={(link) => setParams({ ...params, link })}
                placeholder="Link"
                type="text"
                error={errors.link}
              />

              <button className="primary button">Salvar</button>
            </S.Grid>
          </form>

          <div className="table table-downloads split-rows">
            <div className="table-header">
              <div className="table-header-column">
                <p className="table-header-title">Ordem</p>
              </div>

              <div className="table-header-column">
                <p className="table-header-title">Item</p>
              </div>

              <div className="table-header-column padded">
                <p className="table-header-title">Date</p>
              </div>

              <div className="table-header-column padded-left"></div>
            </div>

            <div className="table-body same-color-rows">
              {banners.map((banner, index) => (
                <div
                  className="table-row medium banner"
                  draggable={true}
                  onDragStart={(evt) => dragStart(evt, index)}
                  onDragEnter={(evt) => dragEnter(evt, index)}
                  onDrop={(evt) => drop(evt)}
                  key={index}
                >
                  <div className="table-column draggable">
                    <div className='product-order'>{index + 1}º</div>
                  </div>

                  <div className="table-column">
                    <div className="product-preview tiny">
                      <figure className="product-preview-image short liquid mb-0">
                        <img src={banner.path} alt="item-11" />
                      </figure>

                      <div className="product-preview-info">
                        <p className="product-preview-title">{banner.link}</p>

                        <p className="product-preview-creator mb-0">
                          {banner.creatorName}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="table-column padded">
                    <p className="table-title">
                      {new Date(banner.createdAt).toLocaleDateString('pt-BR')}
                    </p>
                  </div>

                  <div className="table-column padded-left">
                    <div className="table-actions">
                      <button
                        className="button tertiary"
                        onClick={() => handleDeleteConfirm(banner.id)}
                      >
                        Deletar
                      </button>
                      <button
                        className="button primary"
                        onClick={() => handleEdit(banner)}
                      >
                        Editar
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </S.Container>
      </div>
    </Template>
  )
}

export default AdminBanner
